// @ts-nocheck

import {
  Vue, Options
} from 'vue-class-component'
import Header from '@/components/Header.vue'
import swal from 'sweetalert'
import { userBillFactory } from '@/http/user-bill'
import { masterDataFactory } from '@/http/master-data'
import constants from '@/constants/constants'
import Utils from '@/utils/utils'
import VPagination from '@hennge/vue3-pagination'
import '@hennge/vue3-pagination/dist/vue3-pagination.css'
import roleAccessManager from '@/utils/role-access-manager'

  @Options({
    components: {
      Header,
      VPagination
    },
    data () {
      return {
        dataReady: false,
        masterBills: [],
        months: [],
        month: [],
        students: [],
        billTypes: [],
        studentBills: [],
        totalBill: {
          spp: 0,
          kegiatan: 0,
          ujian: 0
        },
        schoolYears: [],
        classes: [],
        data_master: {
          school_years: '1',
          bill_types: '1',
          classes: '1',
          months: '1'
        },
        param: {
          school_year_id: 0,
          class_id: '',
          bill_type_id: '',
          limit: 20,
          offset: 0
        },
        search: '',
        totalNominals: {},
        totalPaids: {},
        totalUnpaids: {},
        totalRefunds: {},
        totalNominal: 0,
        totalPaid: 0,
        totalUnpaid: 0,
        totalRefund: 0,
        activeTab: '',
        currentPage: 1,
        totalPage: 1,
        canCreate: false,
        canRead: false,
        canUpdate: false,
        canDelete: false
      }
    },
    watch: {
      '$route.query': {
        handler: 'loadData',
        deep: true
      }
    },
    methods: {
      onPageChanged (page: any) {
        if (page) {
          this.currentPage = page
        }
        page = Math.round(this.currentPage)
        if (this.totalPage >= page) {
          // this.$router.push({ query: { page } })
          this.param.offset = (page - 1) * this.param.limit
          this.loadData('next')
        }
      },
      tableDataClass (data: any) {
        if (!data || data == undefined) return {}

        let is_paid = 1
        let duedate, deadlinedate
        let d1 = 0
        let d3 = 0
        let isSuccess; let isPending; let isDeadline = false
        data.forEach((value: any) => {
          if (value.status != constants.BILL_PAID) {
            is_paid = 0
          }
          if (is_paid == 0) {
            duedate = new Date(value.due_date)
            deadlinedate = new Date(value.deadline_date)
            if (d1 == 0 || d1 > deadlinedate.getTime()) {
              d1 = deadlinedate.getTime()
            }
            if (d3 == 0 || d3 > duedate.getTime()) {
              d3 = duedate.getTime()
            }
          }
        })
        if (is_paid == 1) {
          isSuccess = true
        } else if (is_paid == 0) {
          const datenow = new Date()
          datenow.setHours(0, 0, 0, 0)
          const d2 = datenow.getTime()
          if (d2 >= d1) {
            // overdue
            isDeadline = true
          } else if (d2 > d3 && d3 < d1) {
            // duedate
            isPending = true
          }
        }
        return {
          'bg-success-strip text-success': isSuccess,
          'bg-warning-strip text-warning': isPending,
          'bg-danger-strip text-danger': isDeadline
        }
      },
      getMonth: function (date: any) {
        if (date != '' && date != undefined) {
          const d = date.split('-')
          const month = d[2]
          return this.months[month].id
        } else {
          return ''
        }
      },
      getMonthIndex: function (date: any) {
        if (date != '' && date != undefined) {
          const d = date.split('-')
          const month = d[2]
          return month
        } else {
          return 0
        }
      },
      sum: function (total: any, num: any) {
        return total + num
      },
      setRouter: function () {
        this.$router.push({
          path: '/recap/',
          query: {
            school_year: this.param.school_year_id,
            class: this.param.class_id,
            bill_type_id: this.param.bill_type_id,
            t: +new Date()
          }
        })
      },
      loadData: function (method = 'refresh') {
        if (typeof method === 'object') {
          method = 'refresh'
        }

        if (method === 'refresh') {
          this.currentPage = 1
          this.param.offset = 0
        }

        const school_year = this.$route.query.school_year
        if (school_year !== undefined && school_year !== '') {
          this.param.school_year_id = parseInt(school_year)
        }
        const class_id = this.$route.query.class
        if (class_id !== undefined && class_id) {
          this.param.class_id = parseInt(class_id)
        }
        const bill_type_id = this.$route.query.bill_type_id
        if (bill_type_id !== undefined && bill_type_id) {
          this.param.bill_type_id = bill_type_id
        }

        // if (!this.param.school_year_id || !this.param.class_id) {
        if (!this.param.school_year_id) {
          return
        }

        Promise.all([
          userBillFactory.userBillSummary(this.param)
        ]).then(results => {
          let total_page = results[0].data.total_rows
          total_page = Math.ceil(total_page / this.param.limit)
          this.totalPage = total_page || 1
          this.studentBills = results[0].data.bill_users
          this.students = results[0].data.students
          this.totalNominals = {}
          this.totalPaids = {}
          this.totalUnpaids = {}
          this.totalRefunds = {}
          const student_data: any = []
          let c = 0
          // let firstTab = ''
          for (const type in this.billTypes) {
            const i = this.billTypes[type].id
            const tempstudent: any = []
            this.totalNominals[this.slugify(i)] = 0
            this.totalPaids[this.slugify(i)] = 0
            this.totalUnpaids[this.slugify(i)] = 0
            this.totalRefunds[this.slugify(i)] = 0
            for (const j in this.studentBills[i]) {
              const temp: any = []
              const user_bill = this.studentBills[i][j]
              const totalAmount: any = []
              const refundAmount: any = []
              const bills: any = []
              let totalPaid = 0
              let totalUnpaid = 0
              let totalRefund = 0
              for (const k in user_bill) {
                const bill = this.studentBills[i][j][k]
                const index = this.getMonthIndex(bill.id)
                const month = this.getMonth(bill.id)
                if (bills[month] == undefined) {
                  bills[month] = []
                }
                bills[month].push(bill)
                totalAmount[index] = Number.isInteger(totalAmount[index]) ? (parseInt(totalAmount[index]) + parseInt(bill.total_amount)) : parseInt(bill.total_amount) || 0
                const refundAmountForBill = parseFloat(bill.refund_amount || 0)
                refundAmount[index] = Number.isInteger(refundAmount[index]) ? (parseFloat(refundAmount[index]) + refundAmountForBill) : refundAmountForBill || 0
                if (bill.status == constants.BILL_PAID || bill.status == constants.BILL_OVERPAID) {
                  totalPaid += parseInt(bill.total_amount)
                } else {
                  totalUnpaid += parseInt(bill.total_amount)
                }
                totalRefund += refundAmountForBill
              }
              temp.id = j
              temp.name = this.students[j].name
              temp.nis = this.students[j].nis
              temp.nisn = this.students[j].nisn
              temp.class_name = this.students[j].class_name
              temp.detail = totalAmount
              temp.refund_detail = refundAmount
              temp.detail_bill = bills
              temp.total_paid = totalPaid
              temp.total_unpaid = totalUnpaid
              temp.total_refund = totalRefund
              temp.has_refund = totalRefund > 0
              temp.total_bill = totalAmount.reduce(this.sum)

              this.totalNominals[this.slugify(i)] += temp.total_bill
              this.totalPaids[this.slugify(i)] += temp.total_paid
              this.totalUnpaids[this.slugify(i)] += temp.total_unpaid
              this.totalRefunds[this.slugify(i)] += temp.total_refund

              tempstudent.push(temp)
            }
            student_data[i] = tempstudent

            c++
            // if(c === 1){
            //   firstTab = i
            // }
          }
          // if(this.activeTab === ''){
          //   this.activeTab = this.slugify(firstTab)
          // }
          this.setTotalNominal(bill_type_id)
          this.studentBills = student_data
        }).catch((e) => {
        })
      },
      loadDataMaster: function () {
        Promise.all([
          masterDataFactory.master_datas(this.data_master)
        ]).then(results => {
          this.schoolYears = results[0].data.school_years
          const month = results[0].data.months
          const months: any = []
          Object.keys(month).forEach((key: any) => {
            month[key].index = key
            months.push(month[key])
          })
          months.sort((a: any, b: any) => (a.seq > b.seq) ? 1 : -1)
          this.month = months
          this.months = results[0].data.months
          const billTypes = results[0].data.bill_types
          billTypes.forEach((type: any, _: any, __: any) => {
            if (type.status == 1) {
              this.billTypes.push(type)
              if (this.activeTab === '') {
                this.activeTab = this.slugify(type.id)
                this.param.bill_type_id = type.id
              }
            }
          })
          this.classes = results[0].data.classes
          // this.param.class_id = this.classes[0].class_id
          this.schoolYears.forEach((school_year: any) => {
            if (school_year.status == 'Active') {
              this.param.school_year_id = school_year.school_year_id
            }
          })
          this.loadData('refresh')
        }).catch((e) => {
        })
      },
      toLocaleString: function (val: any) {
        return Utils.toLocaleString(val)
      },
      slugify: function (val: any) {
        return Utils.slugify(val)
      },
      exportData: function () {
        Promise.resolve(
          userBillFactory.exportUserBill(this.param)
        ).then((response) => {
        }).catch((e) => {
        })
      },
      setTotalNominal: function (id = '') {
        if (id !== '') {
          this.activeTab = this.slugify(id)
        }
        // this.loadData()
        this.totalNominal = this.totalNominals[this.activeTab] || 0
        this.totalPaid = this.totalPaids[this.activeTab] || 0
        this.totalUnpaid = this.totalUnpaids[this.activeTab] || 0
        this.totalRefund = this.totalRefunds[this.activeTab] || 0
      },
      changeBillTypeId: function (id) {
        this.param.bill_type_id = id

        this.setRouter()
      }
    },
    computed: {
      filteredData: function () {
        let filter: any = []
        const filtered: any = []
        if (this.search != '' && this.search.length > 2) {
          const search = this.search && this.search.toLowerCase()
          for (const type in this.billTypes) {
            const i = this.billTypes[type].id
            filter = this.studentBills[i].filter(function (type: any, _: any, __: any) {
              if (type.name.toLowerCase().includes(search) || type.nis.toLowerCase().includes(search)) {
                return type
              }
            })
            filtered[i] = filter
          }
          return filtered
        } else {
          return this.studentBills
        }
      }
    },
    async mounted () {
      // Check read access to /recap
      if (!roleAccessManager.canRead('/recap')) {
        swal('Error', 'Anda tidak memiliki akses ke halaman ini', 'error')
          .then(() => {
            this.$router.push('/loginpage')
          })
        return
      }

      // Set permission flags
      this.canCreate = roleAccessManager.canCreate('/recap')
      this.canRead = roleAccessManager.canRead('/recap')
      this.canUpdate = roleAccessManager.canUpdate('/recap')
      this.canDelete = roleAccessManager.canDelete('/recap')

      await this.loadDataMaster()

      this.dataReady = true
    }
  })

export default class Dashboard extends Vue {}
